/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col, message, Tooltip} from 'antd';
import {DmsTab, RegionCascader, MyUpload} from 'Components';
import {add, getListSelect, account, customerType} from '../../service/customer/index';
import {sKeylist} from '../../service/dictionary/dataitem';
import {allChildren} from '../../service/zone';
import {peopleList as employee} from '../../service/people';
import {categoryTree} from '../../service/category';
import {nameValidator, checkTel} from '../../utils/regexp.js';
import {showSpin, hideSpin, config} from 'Utils';
import {detail2} from '../../service/channel';

const FormItem = Form.Item;
const Option = Select.Option;

class CustomerAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: parseInt(this.props.params.customerId, 10),
            accountId: '',
            detail: {},
            options: [],//归属区域
            channels: [],//上级渠道
            employee: [],//所属业务员
            channel_rank: [],//渠道等级
            channel_type: [],//渠道类型
            product_categoryTree: [], //产品类型
            customerTypeList: [],
        };
    }

    componentWillMount() { //准备数据
        const self = this;
        categoryTree({}).then(res => { //归属区域
            if (res.data && res.data.length > 0) {
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({product_categoryTree: res.data});
                    }
                }, 200);
            }
        });
        allChildren({id: 0}).then(res => { //归属区域
            if (res.data && res.data.length > 0) {
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({options: res.data});
                    }
                }, 200);
            }
        });
        getListSelect().then(res => { //上级渠道
            if (res.data && res.data.length > 0) {
                let timer = window.setInterval(function () {
                    if (self.mounted) {
                        window.clearInterval(timer);
                        self.setState({channels: res.data});
                    }
                }, 200);
            }
        });
        sKeylist({sKey: 'channel_rank'}).then(res => { //渠道等级
            let timer = window.setInterval(function () {
                if (self.mounted) {
                    window.clearInterval(timer);
                    self.setState({channel_rank: res.data || []})
                }
            }, 200);
        })
        sKeylist({sKey: 'channel_type'}).then(res => { //渠道类型
            let timer = window.setInterval(function () {
                if (self.mounted) {
                    window.clearInterval(timer);
                    self.setState({channel_type: res.data || []})
                }
            }, 200);
        })
        employee({status: 1}).then(res => { //所属业务员
            let timer = window.setInterval(function () {
                if (self.mounted) {
                    window.clearInterval(timer);
                    self.setState({employee: res.data || []})
                }
            }, 200);
        })
    }

    componentDidMount() {
        this.mounted = true;
        const self = this;
        if (this.state.id > 0) {
            detail2(self.state.id).then(res => {
                let data = res.data;
                data.fileIds = (data.filePathList || []).map((x, index) => ({
                    uid: 0 - index - 1,
                    name: `附件 ${index + 1}`,
                    status: 'done',
                    id: x.replace('/api/v1/dms/commonAttachUpload/getFile?id=', ''),
                    url: `${config.server}${x}`,
                    thumbUrl: `${config.server}${x}`,
                }))
                self.setState({
                    ...this.state,
                    detail: data
                })
            })
        }
        this.getCustomerType({
            sKey: 'CUS_TYPE'
        });
        this.getAccount();
    }

    getCustomerType(param) {
        customerType(param).then(res => {
            if (res.code === 200) {
                this.setState({
                    customerTypeList: res.data || []
                });
            }
        });
    }

    getAccount() {
        account().then(res => {
            if (res.code === 200) {
                this.setState({
                    accountId: res.data
                });
            }

        });
    }

    cancelHandle() {
        hashHistory.goBack()
    }

    submitHandle() {
        const self = this;
        const {validateFields, getFieldsValue} = this.props.form;

        validateFields((errors) => {//表单校验
            if (errors) {
                return
            }//表单校验有误，则不执行下面的代码
            var data = {
                ...getFieldsValue() //获取用户输入
            };
            if (!data.adminDiv) {
                data = {
                    ...data,
                    adminDiv: {
                        value: {
                            province: 0,
                            city: 0,
                            county: 0,
                        }
                    }
                }
            }
            const result = {
                ...data,
                ...data.adminDiv.value,
                account: this.state.accountId,
                cusType: data.cusType,
                removeFlag: data.removeFlag,
                channelType: data.channelType ? parseInt(data.channelType, 10) : null,
                rank: data.rank ? parseInt(data.rank, 10) : null,
                parentId: data.parentId ? parseInt(data.parentId, 10) : null,
                areaId: data.areaId ? parseInt(data.areaId, 10) : null,
                employeeId: data.employeeId ? parseInt(data.employeeId, 10) : null,
                employeeNum: data.employeeNum ? parseInt(data.employeeNum, 10) : null,
                fileIds: (data.fileIds || []).map(x => x.id).join(),
            }

            delete result.adminDiv; //删除冗余数据

            showSpin();
            if (self.state.id) {
                delete result.contacts;
                delete result.contactsMobile;
                add({...result, id: self.state.id}).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack()
                })
            } else {
                add(result).then(res => {
                    hideSpin();
                    message[res.status ? 'success' : 'error'](res.message);
                    res.status && hashHistory.goBack()
                })
            }
        })
    }

    setAdminDiv(val) {
        this.setState({
            province: val[0] || 0,
            city: val[1] || 0,
            county: val[2] || 0,
        });
    }

    render() {
        const {detail, id, customerTypeList} = this.state;
        const {getFieldDecorator} = this.props.form;
        const myUploadProps = {
            maxWidth: 360,
            maxHeight: 235,
            maxSize: 1,
            // maxCount: 1,
            antdUploadProps: {
                accept: '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.png,.jpg,.jpeg',
                // listType: 'picture',
                showUploadList: {showRemoveIcon: true},
            },
        };
        return <div className="dms-body">
            <DmsTab options={[`${id > 0 ? '编辑客户' : '新建客户'}`]} defaultKey={0}>
                <Button onClick={this.cancelHandle.bind(this)}>取消</Button>
                <Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
            </DmsTab>
            <div className="dms-table-box">
                <Form layout="horizontal">
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="客户名称：" hasFeedback>
                                {getFieldDecorator('name', {
                                    initialValue: detail.name || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入公司名称'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ],
                                })(<Input placeholder="请输入公司名称"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="客户缩写：" hasFeedback>
                                {getFieldDecorator('sortName', {
                                    initialValue: detail.sortName || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入客户缩写'
                                        },
                                        {
                                            validator: nameValidator
                                        }
                                    ],
                                })(<Input placeholder="请输入公司名称"/>)}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <FormItem label="手机号码：" hasFeedback>
                                {getFieldDecorator('phone', {
                                    initialValue: detail.phone || '',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入手机号码'
                                        },
                                    ],
                                })(<Input placeholder="请输入手机号码"/>)}
                            </FormItem>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <div id="rankBox">
                                <FormItem label="等级：" hasFeedback>
                                    {getFieldDecorator('level', {
                                        initialValue: detail.level || '',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择等级'
                                            }
                                        ],
                                    })(
                                        <Select
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="请选择等级"
                                            getPopupContainer={() => document.getElementById('rankBox')}
                                        >
                                            <Option value='A'>A</Option>
                                            <Option value='B'>B</Option>
                                            <Option value='C'>C</Option>
                                        </Select>)}
                                </FormItem>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <div id="customer-type">
                                <FormItem label="客户类型：" hasFeedback>
                                    {getFieldDecorator('cusType', {
                                        initialValue: detail.cusType ? detail.cusType : '',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择客户类型'
                                            }
                                        ],
                                    })(<Select
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择客户类型"
                                        getPopupContainer={() => document.getElementById('customer-type')}
                                    >
                                        {customerTypeList.map(item => <Option value={item.sKey}
                                                                              key={item.id}>{item.name}</Option>)}
                                    </Select>)}
                                </FormItem>
                            </div>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <div id="customer-status">
                                <FormItem label="状态：" hasFeedback>
                                    {getFieldDecorator('status', {
                                        initialValue: detail.status != undefined ? (detail.status + '') : '',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择状态'
                                            }
                                        ],
                                    })(
                                        <Select
                                            allowClear
                                            style={{width: '100%'}}
                                            placeholder="请选择状态"
                                            getPopupContainer={() => document.getElementById('customer-status')}
                                        >
                                            <Option value='1'>生效</Option>
                                            <Option value='0'>失效</Option>
                                        </Select>)}
                                </FormItem>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Tooltip
                            title="使用二次配送功能时，签署人与手机号码需要匹配，避免影响电签的发起。">
                            <Col className="gutter-row" span={12}>
                                <FormItem label="收货人（签署人）：" hasFeedback>
                                    {getFieldDecorator('seller', {
                                        initialValue: detail.seller || '',
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入收货人（签署人）'
                                            },
                                            {
                                                validator: nameValidator
                                            }
                                        ],
                                    })(<Input
                                        placeholder="请输入收货人（签署人）"/>)}
                                </FormItem>
                            </Col>
                        </Tooltip>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <div id="adminDivBox">
                                <FormItem label="地址：" hasFeedback>
                                    {getFieldDecorator('adminDiv', id > 0 ? {
                                        initialValue: {
                                            province: detail.province ? parseInt(detail.province) : '',
                                            city: detail.city ? parseInt(detail.city) : '',
                                            county: detail.county ? parseInt(detail.county) : '',
                                        },
                                        rules: [
                                            {
                                                required: false,
                                                message: '请选择地址'
                                            },
                                        ],
                                        getValueFromEvent: (e) => {
                                            return e
                                        }
                                    } : {
                                        rules: [
                                            {
                                                required: false,
                                                message: '请选择地址'
                                            },
                                        ],
                                        getValueFromEvent: (e) => {
                                            return e
                                        }
                                    })(<RegionCascader containerId="adminDivBox" placeholder="请选择地址"
                                                       style={{width: '100%'}}/>)}
                                </FormItem>
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label={null} hasFeedback>
                                {getFieldDecorator('address', {
                                    initialValue: detail.address || '',
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入详细地址'
                                        },
                                    ],
                                })(<Input placeholder="请输入详细地址" style={{width: '100%'}}/>)}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="备注：" hasFeedback>
                                {getFieldDecorator('remark', {
                                    initialValue: detail.remark || ''
                                })(<Input placeholder="请输入备注"/>)}
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem
                        label="附件"
                        extra={<small>附件大小应小于1M</small>}
                    >
                        {getFieldDecorator('fileIds', {
                            initialValue: detail.fileIds || undefined,
                            rules: [
                                {
                                    required: false,
                                    message: '请上传商品主图',
                                },
                            ],
                        })(
                            <MyUpload {...myUploadProps}>
                                <Button icon="upload">点击上传</Button>
                            </MyUpload>,
                        )}
                    </FormItem>
                </Form>
            </div>
        </div>
    }
}

export default Form.create()(CustomerAdd)



// WEBPACK FOOTER //
// ./src/routes/customer/add.js